export default {
  testFlag: false,
  userModel:null,
  isLogin:false,
  unRead:0,
  baseDomainURL: '',
  backUrl:'',
  imUrl:'http://im.21teacher.com/renrenim',
  // imUrl:'http://localhost:3000/renrenim',
  // csId:38161,
  csId:42866,
  setUserModel(user){
    //console.log('do ========================>setUserModel')
    this.userModel = user
  },
  setTestFlag(boo){
    this.testFlag = boo
  }
  ,
  setIsLogin(boo){
    this.isLogin = boo
  },
  setBackUrl(boo){
    this.backUrl = boo
  },
  setUnRead(boo){
    this.unRead = boo
  },
  setBaseDomainURL(url){
    this.baseDomainURL = url
  }
}
